import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';
import SafeMuiDatatable from '../generic_components/SafeMuiDatatable';
import TEXT from '../text';
import counterPartColumns from './CounterPartColumns';

const counterPartListMapper = data => ({
  id: data.counterPart.userId,
  salutation: data.counterPart.salutation,
  title: data.counterPart.title,
  firstName: data.counterPart.firstName,
  lastName: data.counterPart.lastName,
  faxNumber: data.counterPart.contactInfo.faxNumber,
  phoneNumber: data.counterPart.contactInfo.phoneNumber,
  phoneNumberMobile: data.counterPart.contactInfo.phoneNumberMobile,
  mailAddress: data.counterPart.contactInfo.mailAddress,
  division: data.counterPart.division,
  hierarchyLevel: data.counterPart.hierarchyLevel,
  position: data.counterPart.position
});

const CounterPartTable = ({ counterPartList = [], onCounterPartClick }) => {
  const filteredCounterPartList = useMemo(() => counterPartList.filter(item => item.counterPart !== null), [counterPartList]);

  const preparedData = useMemo(() => filteredCounterPartList.map(item => [...Object.values(counterPartListMapper(item))]), [
    filteredCounterPartList
  ]);

  const tableOptions = useMemo(
    () => ({
      selectableRows: 'none',
      setRowProps: () => ({
        style: { cursor: 'pointer' }
      })
    }),
    []
  );

  const handleOnRowClick = useCallback(
    /**
     *
     * @param {string[]} rowData
     * @param {{dataIndex: number}} rowMeta
     */
    (rowData, rowMeta) => {
      const selectedCounterPart = filteredCounterPartList[rowMeta.dataIndex];
      onCounterPartClick(rowData[0], selectedCounterPart.companyId);
    },

    [filteredCounterPartList, onCounterPartClick]
  );
  return (
    <div className="h-100 pt-2">
      <SafeMuiDatatable
        title={
          <Box display="flex">
            <Typography variant="h6">{TEXT.tableTitle}</Typography>
          </Box>
        }
        onRowClick={handleOnRowClick}
        tableName="CounterPartTable"
        columns={counterPartColumns.DEFAULT_COLUMNS}
        data={preparedData}
        options={tableOptions}
      />
    </div>
  );
};

CounterPartTable.propTypes = {
  counterPartList: PropTypes.array.isRequired,
  onCounterPartClick: PropTypes.func.isRequired
};

export default CounterPartTable;
